export enum enumPaymentMethods {
    BILL_ME_LATER = 'BILL_ME_LATER',
    PAY_BY_CARD = 'PAY_BY_CARD',
    PAY_BY_CREDIT_CARD_3DPRIOR = 'PAY_BY_CREDIT_CARD_3DPRIOR',
    PAY_BY_CHK_ACCOUNT = 'PAY_BY_CHK_ACCOUNT',
    PAY_BY_CHK_ACCOUNT_3DPRIOR = 'PAY_BY_CHK_ACCOUNT_3DPRIOR',
}

export const paymentPreferenceMapping ={
    'BM': 'BILL_ME_LATER',
    'PI': 'PAY_BY_CARD',            //or PAY_BY_CHK_ACCOUNT
    'FP': 'PAY_BY_CREDIT_CARD_3DPRIOR', //or PAY_BY_CHK_ACCOUNT_3DPRIOR
    'NP': 'NO_PRE_SELECT'
}
// export const BILL_ME_LATER = 'BILL_ME_LATER';
// export const PAY_BY_CARD = 'PAY_BY_CARD';
// export const PAY_BY_CREDIT_CARD_3DPRIOR = 'PAY_BY_CREDIT_CARD_3DPRIOR';
// export const PAY_BY_CHK_ACCOUNT = 'PAY_BY_CHK_ACCOUNT';
// export const PAY_BY_CHK_ACCOUNT_3DPRIOR = 'PAY_BY_CHK_ACCOUNT_3DPRIOR';